var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 157,
    viewBox: "0 0 111 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.692 153.614H14.1444C12.4917 153.614 11.1518 152.26 11.1518 150.59V3.02448C11.1518 1.35414 12.4917 0 14.1444 0H103.692C105.344 0 106.684 1.35414 106.684 3.02448V150.59C106.684 152.26 105.345 153.614 103.692 153.614Z",
    fill: "#095620"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2895 147.048H19.5467C17.894 147.048 16.5541 145.694 16.5541 144.024V9.59066C16.5541 7.92032 17.894 6.56594 19.5467 6.56594H98.2895C99.9423 6.56594 101.282 7.92007 101.282 9.59066V144.024C101.282 145.694 99.9423 147.048 98.2895 147.048Z",
    fill: "#E8F9EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3487 19.6752V39.9841C71.3487 41.2547 70.3214 42.2838 69.0533 42.2838H48.7818C47.5146 42.2838 46.4864 41.2547 46.4864 39.9841V19.6752C46.4864 18.4059 47.5146 17.3755 48.7818 17.3755H69.0533C70.3214 17.3755 71.3487 18.4057 71.3487 19.6752Z",
    fill: "#75C675"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3312 26.7476C63.2328 32.5596 54.6017 32.5586 54.5041 26.7473C54.6027 20.9355 63.2336 20.9365 63.3312 26.7476Z",
    fill: "#E8F9EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1539 40.7101C67.7921 42.1589 51.6538 41.0283 51.3381 41.3666C50.9764 41.3663 50.6776 41.0725 50.6811 40.7101C50.8656 29.8634 66.9714 29.8664 67.1539 40.7101Z",
    fill: "#E8F9EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4326 128.711C66.265 138.607 51.5693 138.605 51.4032 128.711C51.5708 118.815 66.2665 118.817 66.4326 128.711Z",
    fill: "#75C675"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1643 127.958H59.6693C59.5203 127.274 60.1657 124.654 58.9179 124.706C57.6719 124.649 58.314 127.283 58.1663 127.958C57.4921 128.109 54.8724 127.458 54.9201 128.711C54.8669 129.963 57.5003 129.314 58.1663 129.464C58.3155 130.148 57.6699 132.768 58.9177 132.716C60.1637 132.773 59.5216 130.14 59.6693 129.464H62.1643C63.1395 129.479 63.1395 127.944 62.1643 127.958Z",
    fill: "#E8F9EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0476 78.0644H27.7884C26.962 78.0644 26.2921 77.3873 26.2921 76.5521V69.2708C26.2921 68.4356 26.962 67.7585 27.7884 67.7585H90.0476C90.874 67.7585 91.544 68.4356 91.544 69.2708V76.5521C91.544 77.3873 90.874 78.0644 90.0476 78.0644Z",
    fill: "#BCE2CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0464 74.944C55.5481 74.4225 28.4273 76.1436 29.4032 73.9839C29.55 73.1598 28.9095 70.8394 30.3542 70.8788H56.0464C57.4665 70.8377 56.8845 73.1625 56.9975 73.9834C56.9972 74.5139 56.5716 74.944 56.0464 74.944Z",
    fill: "#8BC6A5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0476 61.3876H27.7884C26.962 61.3876 26.2921 60.7105 26.2921 59.8753V52.594C26.2921 51.7588 26.962 51.0817 27.7884 51.0817H90.0476C90.874 51.0817 91.544 51.7588 91.544 52.594V59.8753C91.544 60.7105 90.874 61.3876 90.0476 61.3876Z",
    fill: "#BCE2CB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.738 58.2672H30.1511C28.8996 58.3242 29.5564 55.6327 29.4027 54.9579C28.5217 53.3362 45.4469 54.5604 45.7377 54.2013C46.9892 54.1448 46.3324 56.8363 46.4861 57.5111C46.4864 57.9287 46.1514 58.2672 45.738 58.2672Z",
    fill: "#8BC6A5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3417 58.2672C71.9027 57.7984 48.2186 59.3581 49.2056 57.3713C49.3718 56.5914 48.6859 54.1574 50.0931 54.202H72.3417C73.7263 54.1551 73.0948 56.5946 73.2289 57.3708C73.2292 57.8657 72.8319 58.2672 72.3417 58.2672Z",
    fill: "#8BC6A5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6635 84.4353C26.9061 84.4353 26.2921 85.1094 26.2921 85.941V93.2357C26.2921 94.0674 26.9061 94.7414 27.6635 94.7414H47.7031C48.5332 94.7414 49.2062 94.0674 49.2062 93.2357V85.941C49.2062 85.1094 48.5332 84.4353 47.7031 84.4353H27.6635Z",
    fill: "#BCE2CB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2539 87.193C33.9585 89.7061 37.7793 93.3521 40.1996 91.9619C41.0106 91.3596 39.9448 90.49 39.4015 90.139C39.039 90.007 38.7601 90.5487 38.637 90.9174C38.2958 91.2878 36.0009 89.0799 36.3555 88.7175C36.717 88.5795 37.2474 88.2837 37.1026 87.9225C36.7317 87.392 35.8236 86.3581 35.2539 87.193Z",
    fill: "#8BC6A5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2921 102.618V109.913C26.2921 110.744 26.9061 111.418 27.6635 111.418H47.7031C48.5332 111.418 49.2062 110.744 49.2062 109.913V102.618C49.2062 101.786 48.5332 101.112 47.7031 101.112H27.6635C26.9061 101.112 26.2921 101.786 26.2921 102.618Z",
    fill: "#BCE2CB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2438 106.689C40.0379 106.684 39.6801 106.65 39.6831 106.951V109.014C39.6903 109.372 39.1795 109.26 38.9637 109.276C38.4743 109.322 38.7845 107.862 38.702 107.628C38.7437 107.136 37.2884 107.45 37.0569 107.366C36.9124 107.366 36.7954 107.484 36.7954 107.628C36.7167 107.862 37.0214 109.321 36.534 109.277C36.3207 109.257 35.8052 109.376 35.8146 109.015C35.7237 108.783 36.0602 106.611 35.5532 106.689C35.2822 106.743 34.8077 106.613 35.0555 106.256L37.5503 103.345C37.6546 103.224 37.8428 103.224 37.9471 103.345L40.4419 106.257C40.5879 106.426 40.4673 106.689 40.2438 106.689Z",
    fill: "#8BC6A5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.544 93.2355V85.9408C91.544 85.1091 90.8711 84.4351 90.0409 84.4351H52.9063C52.0762 84.4351 51.4032 85.1091 51.4032 85.9408V93.2355C51.4032 94.0671 52.0762 94.7412 52.9063 94.7412H90.0409C90.8711 94.7412 91.544 94.0671 91.544 93.2355Z",
    fill: "#BCE2CB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5633 91.6135C81.0649 91.0921 53.9442 92.8131 54.9198 90.6534C55.0666 89.8293 54.4262 87.509 55.8709 87.5481H81.5631C82.9832 87.507 82.4011 89.8318 82.5141 90.6526C82.5143 91.1832 82.0885 91.6135 81.5633 91.6135Z",
    fill: "#8BC6A5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0409 111.418C90.8711 111.418 91.544 110.744 91.544 109.912V102.618C91.544 101.786 90.8711 101.112 90.0409 101.112H52.9063C52.0762 101.112 51.4032 101.786 51.4032 102.618V109.912C51.4032 110.744 52.0762 111.418 52.9063 111.418H90.0409Z",
    fill: "#BCE2CB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5633 108.431C81.0649 107.909 53.9442 109.63 54.9198 107.471C55.0666 106.647 54.4262 104.326 55.8709 104.365H81.5631C82.9832 104.324 82.4011 106.649 82.5141 107.47C82.5143 108 82.0885 108.431 81.5633 108.431Z",
    fill: "#8BC6A5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40859 68.4944C24.3349 69.7785 21.9943 64.0259 21.3735 86.4503L23.9466 91.7622C24.4201 92.7399 23.2416 93.682 22.3951 93.0027L18.952 90.2387C18.7556 90.2748 18.5524 90.2914 18.3449 90.2861L2.85213 89.8816C1.23536 89.8394 -0.0411957 88.492 0.00101746 86.8724L0.404768 71.3512C0.446981 69.7311 1.79183 68.4522 3.40859 68.4944Z",
    fill: "#00E741"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51128 74.9147C4.51634 78.4183 8.25197 82.7251 11.234 84.1947C14.6314 85.9496 19.4921 83.7443 14.5812 80.6465C13.8763 80.3895 13.3337 81.4438 13.0938 82.161C12.3114 82.7934 8.05705 78.6996 8.65474 77.881C9.35796 77.6125 10.3899 77.0368 10.1086 76.3339C9.38627 75.3017 7.61926 73.2903 6.51128 74.9147Z",
    fill: "#E8F9EC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8403 98.2939C72.4558 100.865 75.419 109.039 78.7305 109.146C80.4597 109.078 81.994 107.883 83.4936 107.153C88.4772 105.232 89.4325 103.637 90.5196 98.2879C90.9755 95.4325 79.1568 103.992 78.871 104.943C78.899 104.981 78.9202 105.007 78.938 105.033C78.9318 105.031 78.8963 105.017 78.835 104.991C79.2045 104.694 76.8991 102.389 76.6891 102.124C75.2749 100.645 74.1521 98.9165 72.8102 97.3842C72.5395 97.6936 71.5254 98.2713 70.8403 98.2939Z",
    fill: "url(#paint0_linear_9700_15967)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M107.355 148.664C107.355 148.664 108.754 151.105 107.827 153.293C110.108 153.421 111.247 146.143 110.428 144.082C107.221 144.249 106.584 145.795 107.355 148.664Z",
    fill: "url(#paint1_linear_9700_15967)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M105.575 148.28C105.575 148.28 106.742 148.395 107.323 148.482C107.578 148.521 108.038 146.255 107.443 145.167L106 145.378L104.942 147.548L105.575 148.28Z",
    fill: "url(#paint2_linear_9700_15967)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6233 122.01C82.1748 117.009 90.5906 123.801 90.5906 123.801C90.8494 123.211 93.6233 133.982 91.4436 145.583C98.5483 144.831 106.134 145.327 106.134 145.327C107.359 147.12 106.514 148.382 106.514 148.382C99.7077 149.275 94.5592 151.332 86.9958 152.706C86.9958 152.706 84.1002 152.282 83.7511 147.163C83.7312 147.17 83.7126 147.178 83.6927 147.184C83.4045 138.629 82.3191 128.467 81.6233 122.01Z",
    fill: "url(#paint3_linear_9700_15967)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7511 147.163C83.7312 147.17 83.7126 147.178 83.6927 147.184C83.693 147.204 83.6937 147.222 83.6957 147.241L83.7511 147.163Z",
    fill: "url(#paint4_linear_9700_15967)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9654 152.286C95.9654 152.286 97.8657 154.558 97.3075 157C99.6831 156.756 99.5411 148.916 98.3079 146.965C95.0046 147.733 94.6406 149.458 95.9654 152.286Z",
    fill: "url(#paint5_linear_9700_15967)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0474 152.217C94.0474 152.217 95.2793 152.12 95.8981 152.103C96.1695 152.096 96.2296 149.661 95.4114 148.643L93.9538 149.128L93.2568 151.574L94.0474 152.217Z",
    fill: "url(#paint6_linear_9700_15967)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0747 152.22C87.1825 151.518 81.3936 152.356 73.6577 151.941C73.6577 151.941 70.9362 150.86 71.7742 145.799C71.7531 145.8 71.7332 145.804 71.7136 145.806C72.9463 138.704 74.3455 131.556 75.044 124.367L79.2589 120.196C81.0077 121.377 82.5128 122.978 83.8032 124.643C84.1583 124.745 84.4955 134.721 79.6234 146.036C86.71 146.945 93.9766 149.179 93.9781 149.18C94.7559 151.211 94.0747 152.22 94.0747 152.22Z",
    fill: "url(#paint7_linear_9700_15967)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7742 145.799C71.7534 145.8 71.7338 145.803 71.7129 145.805C71.7087 145.824 71.705 145.842 71.7025 145.861L71.7742 145.799Z",
    fill: "url(#paint8_linear_9700_15967)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9138 95.7116C82.841 95.8579 82.4867 96.4707 84.0121 96.5586C86.5337 96.6047 87.3583 96 87.4125 95.9581C87.2749 95.5764 87.2235 91.7789 87.7164 90.6567L83.2979 90.7247C83.4491 91.4274 83.4832 95.0742 82.6925 96.0022C82.7851 95.9091 82.8614 95.811 82.9138 95.7116Z",
    fill: "url(#paint9_linear_9700_15967)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8312 113.251C92.4736 116.335 91.7848 119.859 90.5906 123.801C90.5785 123.804 83.0106 126.104 75.0266 124.384C75.6581 120.981 77.6592 112.49 75.3052 107.724C75.4348 103.346 77.3022 99.3145 81.0586 97C81.7631 96.7212 82.5607 96.5024 82.9029 95.7319C82.8145 95.9079 82.5508 96.4745 84.0121 96.5586C86.5277 96.6067 87.3601 95.9989 87.4105 95.9611C93.8323 95.8142 93.4229 105.926 92.8312 113.251Z",
    fill: "url(#paint10_linear_9700_15967)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1545 97.3579C60.4673 99.7725 61.9746 103.111 63.5161 105.481C66.8668 111.596 68.8585 111.545 74.4994 108.1C80.6427 105.679 81.6305 103.954 83.0201 97.3503C83.5765 93.8864 69.2377 104.269 68.8936 105.421C68.9276 105.467 68.9531 105.499 68.9747 105.531C68.9673 105.528 68.9241 105.511 68.8496 105.48C69.2981 105.119 66.5018 102.324 66.2473 102.003C64.5483 100.109 62.8342 98.1253 61.7118 95.8225C61.5383 96.6005 60.3652 97.1747 59.1545 97.3579Z",
    fill: "url(#paint11_linear_9700_15967)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8312 113.251C92.4736 116.335 91.7848 119.859 90.5906 123.801C90.5785 123.804 83.0106 126.104 75.0266 124.384C85.8861 124.448 90.6996 118.604 92.8312 113.251Z",
    fill: "url(#paint12_linear_9700_15967)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0983 77.4533C82.1698 75.3701 77.1477 78.9261 77.0516 85.1882C77.0288 86.538 76.8607 94.3685 78.8802 94.4802C80.6229 94.5765 80.7403 92.2181 90.3068 93.9474C94.6222 94.7274 96.2931 90.1879 94.469 86.6803C92.0604 83.5766 92.1528 78.9778 88.0983 77.4533Z",
    fill: "url(#paint13_linear_9700_15967)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5556 92.8545C62.1404 92.71 61.1668 94.6968 60.4753 94.1715C60.8539 93.2731 57.381 88.3855 58.5049 91.3982C59.2163 92.5837 59.369 92.6447 59.4529 93.5123C59.2724 92.966 57.8178 91.7222 57.0388 91.2376C56.2822 90.7771 56.4235 91.469 57.0008 91.9727C57.5782 92.4763 58.2022 93.0525 58.2022 93.0525L58.743 94.1549C58.2568 93.7253 57.1166 93.0949 56.5027 92.8723C55.7759 92.6088 56.0158 93.1765 56.5966 93.508C57.1771 93.8395 57.8101 94.225 57.8101 94.225L58.2392 94.7846C57.6678 94.4819 54.5197 94.0937 56.4965 94.9304C57.0292 95.1289 57.9551 94.9891 58.0308 95.7367C58.2851 98.037 60.8326 97.6868 61.7563 96.0815C61.8752 95.367 62.2099 94.694 62.3127 93.9733C62.3443 93.3185 63.0016 93.2267 63.0321 93.0297C63.0624 92.8324 62.9959 92.7873 62.5556 92.8545Z",
    fill: "url(#paint14_linear_9700_15967)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5735 96.47C72.4623 96.0554 72.5028 95.4077 72.3784 95.0732C72.1867 94.4631 72.0263 95.2315 72.106 95.546C71.623 94.0219 70.9906 93.7577 71.6161 95.501C70.7601 93.718 69.5504 92.9729 70.968 95.3874L71.0209 95.8343C70.8632 95.2659 69.6343 93.4605 70.1108 95.0202C70.294 95.4739 71.1363 96.9295 70.2603 96.952C69.6737 96.9405 69.2961 96.7651 69.0425 96.9177C68.789 97.0703 68.7741 97.1217 68.873 97.2093C68.9718 97.2971 69.3465 97.065 69.6397 97.3862C69.9963 97.7107 70.4517 97.9124 70.8155 98.2276C71.9337 98.6816 73.4305 97.7069 72.5735 96.47Z",
    fill: "url(#paint15_linear_9700_15967)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9700_15967",
    x1: 86.8656,
    y1: 104.133,
    x2: 78.2528,
    y2: 91.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF73D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9700_15967",
    x1: 105.803,
    y1: 148.829,
    x2: 111.078,
    y2: 148.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF73D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F45FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9700_15967",
    x1: 105.06,
    y1: 147.187,
    x2: 108.236,
    y2: 146.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABEB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9700_15967",
    x1: 100.073,
    y1: 156.718,
    x2: 84.3511,
    y2: 121.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E00B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0045"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9700_15967",
    x1: 86.625,
    y1: 147.229,
    x2: 86.6033,
    y2: 147.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E00B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0045"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9700_15967",
    x1: 95.59,
    y1: 152.861,
    x2: 101.078,
    y2: 151.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF73D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F45FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9700_15967",
    x1: 94.5531,
    y1: 151.308,
    x2: 97.824,
    y2: 150.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABEB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9700_15967",
    x1: 83.8082,
    y1: 157.25,
    x2: 89.1782,
    y2: 135.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E00B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0045"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9700_15967",
    x1: 75.9201,
    y1: 145.858,
    x2: 75.9157,
    y2: 145.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E00B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0045"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9700_15967",
    x1: 88.0386,
    y1: 91.3764,
    x2: 87.6503,
    y2: 97.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABEB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9700_15967",
    x1: 85.4242,
    y1: 132.35,
    x2: 88.4517,
    y2: 97.7762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF73D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9700_15967",
    x1: 74.2694,
    y1: 129.754,
    x2: 75.6512,
    y2: 97.1891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF73D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9700_15967",
    x1: 85.5079,
    y1: 137.74,
    x2: 87.8548,
    y2: 110.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF73D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F45FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9700_15967",
    x1: 79.7411,
    y1: 70.0639,
    x2: 90.1046,
    y2: 87.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B345FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9700_15967",
    x1: 115.022,
    y1: 98.9107,
    x2: 71.2072,
    y2: 95.5199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABEB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9700_15967",
    x1: 137.654,
    y1: 102.012,
    x2: 80.7852,
    y2: 97.0821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABEB2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowit1);
export default __webpack_public_path__ + "static/media/howit_1.98aed39536fd5f6edd7675bb475731bb.svg";
export { ForwardRef as ReactComponent };